export default __webpack_public_path__ + "static/media/a041-3.384bb16b.png";